<template lang="pug">
  .lazy-load
    slot(:pagination="pagination")
    v-fade-transition(leave-absolute)
      div(
        v-show="value"
        v-intersect="(a, b, isIntersecting) => isIntersecting && loadMore()"
      )
        .loading-animation.pt-5
          .line
          .line
          .line
</template>

<script>
import anime from 'animejs';

export default {
  props: {
    value: { type: [Function, Boolean], default: false },
  },
  data() {
    return {
      pagination: {},
    };
  },
  mounted() {
    anime({
      targets: '.loading-animation .line',
      keyframes: [
        { scale: 0 },
        { scale: 1 },
      ],
      delay: anime.stagger(150),
      loop: true,
    });
  },
  methods: {
    async loadMore() {
      const response = await this.value();
      this.$emit('input', response.loadMore);
      this.$emit('on-response', response);
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-animation {

  text-align: center;

  .line {
    display: inline-block;
    height: 10px;
    width: 10px;
    margin: 3px 10px;
    border-radius: 25px;
    background-color: $secondary-color;
  }
}
</style>
